import axios from 'axios';
import Common from './Common';
export default {
    getPersonal(id) {
        return axios.get(Common.api + 'get-personal-text/' + id);
    },
    getPortfolioCat() {
        return axios.get(Common.api + 'category-list-dropdown');
    },
    getServiceList(id) {
        return axios.get(Common.api + 'get-service-profile/' + id);
    },
    getPortfolio(id) {
        return axios.get(Common.api + 'get-portfolio-profile/' + id);
    },
    getPortfolioAll(id) {
        return axios.get(Common.api + 'get-portfolio-all/' + id);
    },
    getPortfolioDetails(id) {
        return axios.get(Common.api + 'get-portfolio/' + id);
    },
    getResidentials() {
        return axios.get(Common.api + 'residentials');
    },
    getSex() {
        return axios.get(Common.api + 'sex');
    },
    getBasics(id) {
        return axios.get(Common.api + 'get-basic-profile/' + id);
    },
    getProfile(id) {
        return axios.get(Common.api + 'get-profile/' + id);
    },
    getConfiguration(id) {
        return axios.get(Common.api + 'get-config-profile/' + id);
    },
    saveBuyerProfile(data) {
        return axios.post(Common.api + 'update-basic-profile' , data);
    },
    saveIntroductoryText(data) {
        return axios.post(Common.api + 'upload-personal-text', data);
    },
    savePortfolio(data) {
        return axios.post(Common.api + 'upload-portfolio-item', data);
    },
    checkusername(name, id) {
        return axios.get(Common.api + 'check-username-dup/' + name +'/'+ id);
    },
    passwordResetLink(data) {
        return axios.post(Common.api + 'send-password-reset-link', data);
    },
    ResetPass(data) {
        return axios.post(Common.api + 'save-new-pass', data);
    },
    checkLink(code) {
        return axios.get(Common.api + 'check/' + code);
    }
}